var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "sheets_rtl"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3772_29580",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 19.1667,
    transform: "matrix(-1 0 0 1 20 0.416687)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3772_29580)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sheets_rtl_2",
    d: "M15.1203 11.0742C15.4354 11.0742 15.7025 10.9647 15.9216 10.7457C16.1406 10.5267 16.2501 10.2596 16.2501 9.94438V3.03738C16.2501 2.72222 16.1406 2.45513 15.9216 2.23611C15.7025 2.0171 15.4354 1.90759 15.1203 1.90759H4.87995C4.56478 1.90759 4.29769 2.0171 4.07868 2.23611C3.85965 2.45513 3.75013 2.72222 3.75013 3.03738V9.94438C3.75013 10.2596 3.85965 10.5267 4.07868 10.7457C4.29769 10.9647 4.56478 11.0742 4.87995 11.0742H15.1203ZM15.0001 5.86591H10.6251V3.15755H14.8078C14.8612 3.15755 14.9066 3.17625 14.944 3.21366C14.9814 3.25104 15.0001 3.29645 15.0001 3.34988V5.86591ZM9.37513 5.86591H5.00011V3.34988C5.00011 3.29645 5.01881 3.25104 5.05622 3.21366C5.09361 3.17625 5.13901 3.15755 5.19243 3.15755H9.37513V5.86591ZM10.6251 9.82422V7.11588H15.0001V9.6319C15.0001 9.68532 14.9814 9.73073 14.944 9.76813C14.9066 9.80552 14.8612 9.82422 14.8078 9.82422H10.6251ZM9.37513 9.82422H5.19243C5.13901 9.82422 5.09361 9.80552 5.05622 9.76813C5.01881 9.73073 5.00011 9.68532 5.00011 9.6319V7.11588H9.37513V9.82422ZM14.1668 18.2136L17.2036 15.1768L14.1668 12.1399L13.2886 13.0101L14.8094 14.5518H3.5418V15.8017H14.8094L13.2886 17.3434L14.1668 18.2136Z",
    fill: "#1D4650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.893ead5b1757b962f1951827962b4836.svg";
export { ForwardRef as ReactComponent };